import {
  Container,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { DirectionsRun, EmojiPeople } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { handleBackendMessage, renderToaster } from "../../common";
import "./Overview.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getUserInterfaceList } from "../../store/actions/userActions";
import { useTheme } from "@mui/material/styles";
import Settings from "../Profile/Settings";

const useStyles = makeStyles((theme) => ({
  button: {
    width: 60,
    height: 60,
    padding: 0,
  },
}));

const Overview = ({ history }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [pageLoaded, setPageLoaded] = useState(false);
  const { t } = useTranslation("translation");
  const [userIList, setUserIList] = useState([]);

  useEffect(() => {
    OperatorTechnicianPage();
  }, []);

  const {
    user: { userInterfaceList },
    user: { showMessage },
  } = useSelector((user) => user);

  useEffect(() => {
    if (showMessage?.response)
      renderToaster(
        enqueueSnackbar,
        handleBackendMessage(showMessage),
        "error"
      );
  }, [showMessage]);

  useEffect(() => {
    if (userInterfaceList?.resultObject) {
      let interfaceList = userInterfaceList?.resultObject?.interfaceList;
      localStorage.setItem(
        "authorizedToApprove",
        JSON.stringify(userInterfaceList?.resultObject?.authorizedToApprove)
      );
      CheckInterfaceList(interfaceList);
      setUserIList(interfaceList);
      setPageLoaded(true);
    }
  }, [userInterfaceList]);

  const OperatorTechnicianPage = () => {
    dispatch(getUserInterfaceList());
  };

  const CheckInterfaceList = (interfaceList) => {
    if (
      interfaceList?.includes("ProdOperator") &&
      interfaceList?.includes("MaintTeamMember")
    ) {
      return null;
    } else if (interfaceList?.includes("ProdOperator")) {
      OpenOperatorPage();
    } else if (interfaceList?.includes("MaintTeamMember")) {
      OpenTechnicianPage();
    }
  };

  const OpenOperatorPage = () => {
    if (userIList?.includes("VIEWER")) {
      history.push("/autonomous-maintenance-list");
    } else {
      history.push("/operatormainpage");
    }
  };
  const OpenTechnicianPage = () => {
    if (userIList?.includes("VIEWER")) {
      history.push("/lists");
    } else {
      history.push("/technicianmainpage");
    }
  };

  window.addEventListener("beforeunload", function (event) {
    if (event.origin !== "https://most-test.arcelik.com/") {
      event.returnValue = "Do you want to leave?";
    }
  });

  const theme = useTheme();
  const mostLogo =
    theme.palette.mode === "light" ? "most.png" : "most_dark.png";

  return pageLoaded ? (
    <div align="center">
      <img src={mostLogo} alt="MOST" width="300" style={{ marginTop: 150 }} />
      <Container fixed maxWidth="xs" style={{ marginTop: 20 }}>
        <Grid container justifyContent="center">
          <Grid item xs={6} sm={6} md={6}>
            <Typography component="h6">{t("Technician")}</Typography>
            <Divider variant="middle" />
            <IconButton
              id="ov_OpenTechnicianPageButon"
              onClick={OpenTechnicianPage}
              size="large"
            >
              <DirectionsRun
                sx={{
                  width: 60,
                  height: 60,
                  color: theme.palette.mode === "light" ? "#545454" : "#c8c8c8",
                }}
                color="primary"
              />
            </IconButton>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <Typography component="h6">{t("Operator")}</Typography>
            <Divider variant="middle" />
            <IconButton
              id="ov_OpenOperatorPageButton"
              onClick={OpenOperatorPage}
              size="large"
            >
              <EmojiPeople
                sx={{
                  width: 60,
                  height: 60,
                  color: theme.palette.mode === "light" ? "#9c0404" : "#b82323",
                }}
                color="secondary"
              />
            </IconButton>
          </Grid>
        </Grid>
        <Settings fromOverview={true} />
      </Container>
    </div>
  ) : null;
};

export default Overview;
